import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type AppLogoProps = {
  className?: string
  showText?: boolean
  iconHeight?: string
  /** Use "light" on white/light backgrounds (dark text), "dark" on colored headers (white text) */
  variant?: 'light' | 'dark'
}

const BRAND_NAME = 'Passe Moi Ton Bail'

const AppLogo = ({
  className = '',
  showText = true,
  iconHeight = 'h-10',
  variant = 'dark',
}: AppLogoProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const textClass = variant === 'light' ? 'text-imovSecondary' : 'text-white'

  return (
    <button
      type="button"
      onClick={() => navigate('/')}
      className={`flex items-center gap-2 rounded outline-none focus:outline-none ${className}`}
      aria-label={`${BRAND_NAME} - ${t('common.home')}`}
    >
      <img
        src="/logo.svg"
        alt=""
        className={`${iconHeight} w-auto flex-shrink-0 opacity-95`}
      />
      {showText && (
        <span className={`whitespace-nowrap text-lg font-semibold ${textClass}`}>
          {BRAND_NAME}
        </span>
      )}
    </button>
  )
}

export default AppLogo
